import { PrefetchDataMapType } from '@/typings/types'
import Block from './block'
import Text from './text'
import RichText from './rich-text'
import Title from './title'
import Share from './poizon-share'
import PoizonBanner from './poizon-banner'
import PoizonCoupon from './poizon-coupon'
import PoizonTopbar from './poizon-top-bar'
import PoizonImg from './poizon-img'
import PoizonNewProductFlow from './poizon-newProductFlow'
import PoizonLatestBid from './poizon-latest-bid'
import PoizonBackTop from './poizon-back-top'
import PoizonDownloadBar from './poizon-download-bar'
import PoizonActivitySpike from './poizon-activity-spike'
import poizonExplosiveBigPicture from './poizonExplosiveBigPicture'
import poizonNewUserCoupon from './poizon-new-user-coupon'
import poizonBooklist from './poizon-booklist'
import PoizonCouponActivity from './poizon-coupon-activity'
import PoizonShoppingGuideBanner from './poizon-shopping-guide-banner'

import PoizonARowGoods from './poizon-a-row-goods'
import PoizonNewUserCouponV3 from './poizon-new-user-coupon-v3'
import PoizonBrandWall from './poizon-brand-wall'
import PoisonSliderBanner from './poizon-slide-banner'
import PoizonFission from './poizon-fission'
import PoizonBrandPromotion from './poizon-brand-promotion'

const componentMap = {
  [Block.config.name]: Block,
  [Text.config.name]: Text,
  [RichText.config.name]: RichText,
  [Title.config.name]: Title,
  [PoizonBanner.config.name]: PoizonBanner,
  [Share.config.name]: Share,
  [PoizonCoupon.config.name]: PoizonCoupon,
  [PoizonTopbar.config.name]: PoizonTopbar,
  [PoizonImg.config.name]: PoizonImg,
  [PoizonNewProductFlow.config.name]: PoizonNewProductFlow,
  [PoizonLatestBid.config.name]: PoizonLatestBid,
  [PoizonBackTop.config.name]: PoizonBackTop,
  [PoizonDownloadBar.config.name]: PoizonDownloadBar,
  [PoizonActivitySpike.config.name]: PoizonActivitySpike,
  [poizonExplosiveBigPicture.config.name]: poizonExplosiveBigPicture,
  [poizonNewUserCoupon.config.name]: poizonNewUserCoupon,
  [poizonBooklist.config.name]: poizonBooklist,
  [PoisonSliderBanner.config.name]: PoisonSliderBanner,
  [PoizonCouponActivity.config.name]: PoizonCouponActivity,
  [PoizonARowGoods.config.name]: PoizonARowGoods,
  [PoizonNewUserCouponV3.config.name]: PoizonNewUserCouponV3,
  [PoizonShoppingGuideBanner.config.name]: PoizonShoppingGuideBanner,
  [PoizonBrandWall.config.name]: PoizonBrandWall,
  [PoizonFission.config.name]: PoizonFission,
  [PoizonBrandPromotion.config.name]: PoizonBrandPromotion,
}

export const prefetchDataMap: PrefetchDataMapType = Object.keys(componentMap).reduce((pre, cur) => {
  const asyncData = (componentMap[cur] as any).asyncData
  if (typeof asyncData === 'function') {
    return {
      ...pre,
      [cur]: asyncData,
    }
  }
  return pre
}, {} as PrefetchDataMapType)

export default componentMap
